import React, { useState, useMemo } from 'react';
import { Radio, Input, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Modal from './Modal';

const { Text } = Typography;

const SelectNiboCompaniesModal = ({ open, companies, selected, onChange, onOk, onCancel, okLoading = false }) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return companies;
    return companies.filter(c =>
      (c.name || c.label || '').toLowerCase().includes(term)
    );
  }, [companies, search]);

  return (
    <Modal
      title="Selecione a empresa Nibo"
      open={open}
      onOk={onOk}
      onCancel={() => {
        setSearch('');
        onCancel();
      }}
      okText="Confirmar"
      cancelText="Cancelar"
      width={600}
      okButtonProps={{ disabled: !selected || okLoading, loading: okLoading }}
    >
      <div style={{ marginBottom: 12 }}>
        <Text style={{ display: 'block', fontSize: 14, color: '#8c8c8c', marginBottom: 12 }}>
          Selecione a empresa que deseja sincronizar com o Nibo:
        </Text>
        <Input
          prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
          placeholder="Buscar empresa..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          allowClear
          style={{ marginBottom: 12 }}
        />
      </div>

      <Radio.Group
        value={selected}
        onChange={e => onChange(e.target.value)}
        style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}
      >
        {filtered.map(company => {
          const value = company.id || company.value;
          const label = company.name || company.label;
          const exists = company.alreadyExists;
          return (
            <Radio key={value} value={value} style={{ alignItems: 'center' }}>
              <span style={{ fontWeight: exists ? 700 : 400 }}>
                {label}
              </span>
              {exists && (
                <Text type="warning" style={{ marginLeft: 8, fontSize: 12 }}>
                  (já integrada)
                </Text>
              )}
            </Radio>
          );
        })}
        {filtered.length === 0 && (
          <Text type="secondary" style={{ padding: '8px 0' }}>
            Nenhuma empresa encontrada.
          </Text>
        )}
      </Radio.Group>
    </Modal>
  );
};

export default SelectNiboCompaniesModal;
